import { AdminAuditEntry, AdminModuleKey } from '../types';
import { readStorage, writeStorage } from './adminStorage';

const STORAGE_KEY = 'coh-admin-audit-log';

interface RecordAuditEntryInput {
  module: AdminModuleKey;
  action: string;
  description: string;
  actorEmail: string;
  targetId?: string;
  targetLabel?: string;
}

const seedEntries: AdminAuditEntry[] = [
  {
    id: 'audit-seed-1',
    module: 'overview',
    action: 'dashboard_initialized',
    description: 'Admin dashboard foundation initialized for the current app.',
    actorEmail: 'system@circleofhumanity.admin',
    createdAt: new Date().toISOString(),
  },
];

export const AuditLogService = {
  async listEntries(): Promise<AdminAuditEntry[]> {
    const items = readStorage<AdminAuditEntry[]>(STORAGE_KEY, seedEntries);
    return [...items].sort((a, b) => b.createdAt.localeCompare(a.createdAt));
  },

  async recordEntry(input: RecordAuditEntryInput): Promise<void> {
    const items = await this.listEntries();
    const entry: AdminAuditEntry = {
      id: crypto.randomUUID(),
      createdAt: new Date().toISOString(),
      ...input,
    };

    writeStorage(STORAGE_KEY, [entry, ...items].slice(0, 100));
  },
};
